import ProfitCalculator from './ProfitCalculator';

export default ProfitCalculator;
